<template>
  <div class="select-box">
    <Titles :title="data.title" />
    <div class="select-level">
      <!-- 左侧box -->
      <div class="left-card">
        <img class="left-img" v-lazy-load data-src="~assets/images/courses/testPic.png">
        <div class="left-detail">
          <div class="left-title font-medium">
            {{ evaluationName }}
          </div>
          <!-- <div class="left-desc font-medium">
            {{ data.description }}
          </div> -->
        </div>
        <div class="left-arrow" @click="quizHandle">
          <div class="arrow-bg" />
        </div>
      </div>
      <div class="right-card font-medium">
        {{ data.description }}
      </div>
    </div>
  </div>
</template>
<script>
import Titles from 'components/courses/UkCourseTitle'

import evaluation from 'common/evaluation.js'

export default {
  components: { Titles },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      evaluationName: this.$t('evaluation.name'),
    }
  },
  methods: {
    quizHandle() {
      evaluation.toEvaluation(this.$store, `/evaluation/instruction/${this.data.examId}`, 'class_register_pop_up')

      // const urlArr = this.data.url.split('/')
      // const testId = urlArr[urlArr.length - 1]
      // this.Sensors.track('grade_page_test_click', {
      //   grade_name: this.$route.query.name,
      //   test_id: testId,
      // })
      // window.open(this.data.url)
    },
  },
}

</script>
<style lang="scss" scoped>
.select-box {
  width: 1240px;
  margin: 0 auto;
  padding-bottom: 50px;
}

.select-level {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  border: 3px solid #eaedf0;
  display: flex;

  .left-card {
    width: 737px;
    background: #fff;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    padding: 29px 30px;
    justify-content: space-between;

    .left-img {
      width: 60px;
      height: 60px;
      margin-right: 12px;
    }

    .left-detail {
      margin-right: auto;

      .left-title {
        font-size: 20px;
        color: var(--txt-color-lv1);
        line-height: 24px;
        margin-bottom: 3px;
      }

      .left-desc {
        font-size: 16px;
        color: var(--txt-color-lv2);
        line-height: 19px;
        letter-spacing: -0.4px;
      }
    }

    .left-arrow {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      border-radius: 50%;
      background: var(--txt-color-link);
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      transition: width 0.5s linear;

      .arrow-bg {
        background: url('~assets/images/courses/testArrow.png') no-repeat;
        background-size: 100%;
        width: 20px;
        height: 20px;
      }

      &:hover {
        width: 70px;
        border-radius: 20px;
      }
    }
  }

  .right-card {
    width: 440px;
    padding: 30px;
    word-spacing: -1px;
    font-size: 18px;
    color: var(--txt-color-lv3);
    box-sizing: content-box;
    line-height: 21px;
  }
}
</style>
